import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-warning-screen',
  templateUrl: './warning-screen.component.html',
  styleUrls: ['./warning-screen.component.scss']
})
export class WarningScreenComponent {
  @Input() isModalOpened = false;
  @Input() messageToDisplay = '';
  @Input() headerMessage = '';
  @Input() yesNoOptions = true;
  @Output() communicate = new EventEmitter<boolean>();
  @Output() warningOpenChanged = new EventEmitter<boolean>();

  sendMessage(val: boolean) {
    this.communicate.emit(val);
  }

  modalChanged(val: boolean) {
    this.warningOpenChanged.emit(false);
  }
}
